import StatusTag from 'ui/atoms/status-tag';
import styled from 'styled-components';

export const PublicationStatusTag = styled(StatusTag)`
  font-weight: normal;
`;
